// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1aoNT","notes":"Notes_notes__3jLHH"};